import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, TextField, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useGetProfileQuery } from '../features/api/rest/apiProfileSlice';
import { useAddNewAnswerMutation, useGetAnswersQuery } from '../features/api/rest/apiAnswersSlice';
import Error from './Error';
import Spinner from './Spinner';
import AnswersResults from './AnswersResults';

function CheckAnswers({ id, owner }) {
  const { ean } = useParams();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [answer, setAnswer] = useState('');

  const [addNewAnswer, { isLoadingAddQuestion }] = useAddNewAnswerMutation();

  const { currentData, status } = useGetProfileQuery(undefined, { refetchOnMountOrArgChange: true });

  const { count, isLoading, isFetching, isError } = useGetAnswersQuery(
    { ean, Q: id, mine: true },
    {
      selectFromResult: ({ data }) => ({
        count: data?.count,
      }),
    }
  );

  const handleAnswerClick = () => {
    setOpen(!open);
  };

  const handlePostAnswer = async (e) => {
    e.preventDefault();
    try {
      await addNewAnswer({ payload: { body: answer }, ean, Q: id }).unwrap();
      setAnswer('');
      setOpen(false);
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading || isFetching || isLoadingAddQuestion) return <Spinner />;
  if (isError) return <Error />;

  return (
    <>
      {status === 'fulfilled' && owner !== currentData.username && count === 0 && (
        <Button onClick={handleAnswerClick} sx={{ ml: '4em' }}>
          {t('questionsAnswers.addAnswers')}
        </Button>
      )}
      <AnswersResults questionId={id} />
      <Dialog open={open} onClose={handleAnswerClick} fullWidth maxWidth="sm">
        <DialogTitle>{t('questionsAnswers.addAnswers')}</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" id="answer" label={t('questionsAnswers.addAnswers')} type="text" fullWidth variant="standard" required onChange={(e) => setAnswer(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAnswerClick}>{t('common.actions.cancel')}</Button>
          <Button onClick={handlePostAnswer}>{t('common.actions.post')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

CheckAnswers.propTypes = {
  id: PropTypes.number.isRequired,
  owner: PropTypes.string.isRequired,
};

export default CheckAnswers;
